(function(){
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var toastTimer;

  function openMenu(){var m=$('[data-sb-menu]');if(m){m.hidden=false;document.body.style.overflow='hidden'}}
  function closeMenu(){var m=$('[data-sb-menu]');if(m){m.hidden=true;document.body.style.overflow=''}}
  function openCart(){var d=$('[data-sb-drawer]');var s=$('[data-sb-scrim]');if(d){d.hidden=false}if(s){s.hidden=false}document.body.style.overflow='hidden'}
  function closeCart(){var d=$('[data-sb-drawer]');var s=$('[data-sb-scrim]');if(d){d.hidden=true}if(s){s.hidden=true}document.body.style.overflow=''}

  function toast(msg){
    var t=$('[data-sb-toast]');if(!t)return;
    $('[data-sb-toast-text]',t).textContent=msg;t.hidden=false;
    clearTimeout(toastTimer);toastTimer=setTimeout(function(){t.hidden=true},3600);
  }

  function refreshCart(){
    return fetch(window.location.pathname+'?sections=sb-cart-drawer',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(data){
        var html=data['sb-cart-drawer'];if(!html)return;
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var fresh=tmp.querySelector('[data-sb-cart-root]');
        var cur=$('[data-sb-cart-root]');
        if(fresh&&cur){
          var wasOpen=!$('[data-sb-drawer]').hidden;
          cur.replaceWith(fresh);
          if(wasOpen){openCart()}
        }
        return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
          $$('[data-sb-count]').forEach(function(el){el.textContent=c.item_count});
        });
      });
  }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-sb-cart-open]');
    if(t){e.preventDefault();openCart();return}
    if(e.target.closest('[data-sb-cart-close]')||e.target.closest('[data-sb-scrim]')){e.preventDefault();closeCart();return}
    if(e.target.closest('[data-sb-menu-open]')){e.preventDefault();openMenu();return}
    if(e.target.closest('[data-sb-menu-close]')){e.preventDefault();closeMenu();return}
  });

  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();closeMenu()}});

  document.addEventListener('submit',function(e){
    var form=e.target.closest('[data-sb-add]');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('button[type=submit]');
    var label=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Adding…'}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.querySelector('[name=id]').value,quantity:parseInt(form.querySelector('[name=quantity]')?form.querySelector('[name=quantity]').value:1,10)||1}]})})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,body:j}})})
      .then(function(res){
        if(!res.ok){toast(res.body.description||'Could not add to bag');return}
        toast((form.getAttribute('data-sb-name')||'Item')+' added to your bag');
        return refreshCart();
      })
      .catch(function(){toast('Network error — please try again')})
      .finally(function(){if(btn){btn.disabled=false;btn.textContent=label}});
  });

  document.addEventListener('click',function(e){
    var c=e.target.closest('[data-sb-change]');
    if(!c)return;
    e.preventDefault();
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:parseInt(c.getAttribute('data-line'),10),quantity:parseInt(c.getAttribute('data-qty'),10)})})
      .then(function(){return refreshCart()})
      .catch(function(){toast('Could not update your bag')});
  });

  // Reveal on scroll
  if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var pending=$$('[data-sb-reveal]').filter(function(n){return n.getBoundingClientRect().top>window.innerHeight*0.92});
    pending.forEach(function(n){n.style.opacity='0'});
    var sweep=function(){
      pending=pending.filter(function(n){
        if(n.getBoundingClientRect().top>window.innerHeight*0.92)return true;
        n.style.opacity='';n.style.animation='sbUp .7s cubic-bezier(.2,.7,.2,1) both';return false;
      });
      if(!pending.length){window.removeEventListener('scroll',sweep);window.removeEventListener('resize',sweep)}
    };
    window.addEventListener('scroll',sweep,{passive:true});
    window.addEventListener('resize',sweep,{passive:true});
    sweep();
  }
})();
